import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/file-audio': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M369.9 97.9c7.8 7.8 14.1 23 14.1 33.9v332.1c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-416c0-26.5 21.5-48 48-48h204.1c11 0 26.2 6.3 33.9 14.1zM332.1 128l-76.1-76.1v76.1h76.1zM48 464h288v-288h-104c-13.3 0-24-10.7-24-24v-104h-160v416zM192 388c0 10.7-12.9 16-20.5 8.5l-35.5-36h-28c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.9c7.6-7.6 20.5-2.2 20.5 8.5v136zM233.2 340.8c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.4-56.9-10.3-34.4-33.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/file-audio.js
// module id = 1730
// module chunks = 0